module.exports = __webpack_public_path__ + "static/media/diretor-presidente.d1aefc9a.png";